<template>
    <div class="gap-sm flex items-center">
        <AvatarArea v-if="firstName" :first-name="firstName" :last-name="lastName" :size="size" />
        <span class="block overflow-hidden text-ellipsis">{{ displayName }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import AvatarArea from '@/components/avatar-area.vue';
import type { AvatarNameCellProps } from '../types';

const props = withDefaults(defineProps<AvatarNameCellProps>(), {
    size: 'x-small',
});

const displayName = computed(() => {
    if (!props.firstName && !props.lastName) return '-';
    return `${props.firstName || ''} ${props.lastName || ''}`.trim();
});
</script>
